// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2udYm","approved":"Status_approved__2GOjA","rejected":"Status_rejected__2tB9c","expired":"Status_expired__3pIYr","label":"Status_label__PXjsk"};